import _ from "lodash";
import store from "@/store";
import { CookieKeys, Cookies } from "@/utils/cookieKey";
/** 服务热线 **/
export function getServicePhone() {
  try {
    if (store.getters["basic/isPayBefore"]) {
      return "400-900-6616";
    } else {
      return "400-688-2000";
    }
  } catch (e) {
    return "400-900-6616";
  }
}

/**
 * 判断数据是否为空
 * @param {*} value 数据
 * @returns boolean
 */
export function isValEmpty(value) {
  if (typeof value === "object" && value !== null) {
    // isEmpty 方法可以检查 value 是否为一个空对象、集合、映射或者 set。
    return _.isEmpty(value);
  } else {
    // isNil 方法可以检查一个值是否是 null 或者 undefined
    return _.isNil(value) || value === "";
  }
}


// 清除cookies
export function clearCookies() {
  try {
    Cookies.remove(`${Cookies.get(CookieKeys.qlm_username)}${Cookies.get(CookieKeys.qlm_password)}`, "", {
      path: "/",
      domain: ".qianlima.com",
    });
  } catch (e) {
    console.error("clear Cookies error: ", e);
  }
  Cookies.remove(CookieKeys.qlm_username, { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.qlm_password, { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.xAuthToken, { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.userInfo, { path: "/", domain: ".qianlima.com" });
  Cookies.remove(CookieKeys.userAppMenu, {
    path: "/",
    domain: ".qianlima.com",
  });
  Cookies.remove(CookieKeys.userLeftMenuClick, {
    path: "/",
    domain: ".qianlima.com",
  });
}

// 退出登录
export function logOutOfLogin() {
  // 清除cookies
  clearCookies();
  // 刷新当前页
  window.location.href = "/";
}
/** 深拷贝 **/
export function deepClone(source) {
  if (!source) return;
  const targetObj = source.constructor === Array ? [] : {}; // 判断复制的目标是数组还是对象
  for (let keys in source) {
    // 遍历目标
    if (Object.hasOwnProperty.call(source, keys)) {
      if (source[keys] && typeof source[keys] === "object") {
        // 如果值是对象，就递归一下
        targetObj[keys] = source[keys].constructor === Array ? [] : {};
        targetObj[keys] = deepClone(source[keys]);
      } else {
        // 如果不是，就直接赋值
        targetObj[keys] = source[keys];
      }
    }
  }
  return targetObj;
}



//时间戳转换年月日格式
export function getData(n) {
  let now = new Date(n),
    y = now.getFullYear(),
    m = now.getMonth() + 1,
    d = now.getDate();
  return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
}





// 获取登录状态
export const getLoginStatus = () => {
  return (
    (Cookies.get(CookieKeys.qlm_username) && Cookies.get(CookieKeys.qlm_password)) || Cookies.get(CookieKeys.userInfo)
  );
};
// 是否爬虫访问
export const isSpider = () => {
  const UA = navigator.userAgent;
  const isSpider = UA.toLowerCase().indexOf("spider") !== -1;
  return isSpider;
};



export function isBrowserEnvironment() {
  
  return typeof window !== "undefined";
}
export function isHeadlessBrowser() {
  return /HeadlessChrome/.test(window.navigator.userAgent);
}
export const formatCurrentLocationUrl = (obj) => {
  const strId = (obj.id + "").padStart(4, "0");
  const text = obj.title ? `${obj.title}招标信息`: `${obj.name}${obj.keyword}招标信息`;
  return {
    url: `/hot${obj.wId}${strId}`,
    text,
  };
};

/**
 * 高亮
 * @param {String} str
 * @param {Array} keywords
 * @returns
 */
export const highlight = (str, keywords) => {
  let formatStr = str;
  let keywordsJoin = keywords.join("|");

  // 格式化特殊字符
  const specialCharacter = ["\\", "$", "(", ")", "*", "+", ".", "[", "?", "^", "{"];
  specialCharacter.forEach((v) => {
    let reg = new RegExp("\\" + v, "gim");
    keywordsJoin = keywordsJoin.replace(reg, "\\" + v);
  });

  return formatStr.replace(new RegExp(`(${keywordsJoin})`, "g"), '<span style="color: #df6250">$1</span>');
};